import React from 'react';
import Box from '../../Common/Forms/Box';
import {
  FormControl,
  InputLabel,
  Input,
  InputAdornment,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
import {
  Visibility,
  VisibilityOff,
} from '@material-ui/icons';


export default function FieldSenha (props) {
  const { getValue, getError, name, label, toggle, show, setValue, setTouch } = props;
  const value = getValue(name);
  const error = getError(name);
  const hasError = Boolean(error)
  return (
    <Box id={name}>
    <FormControl error={hasError}>
      <InputLabel htmlFor={name}>{label}</InputLabel>
      <Input
        id={name}
        type={show ? 'text' : 'password'}
        value={value}
        onBlur={setTouch(name)}
        onChange={setValue(name)}
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="Mostrar senha" onClick={toggle}>
              {show ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        }
      />
    {hasError && (
      <FormHelperText>{error}</FormHelperText>
    )}
    </FormControl>
    </Box>
  )
}
